import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=8bb0c270&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=8bb0c270&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb0c270",
  null
  
)

export default component.exports